// extracted by mini-css-extract-plugin
export default {"customErrorContainer":"CustomError_customErrorContainer__8vqGk","customErrorIcon":"CustomError_customErrorIcon__7FSWk","customErrorMessage":"CustomError_customErrorMessage__0XKE9"};